<ui-object-navigation-main-page alias="eu"></ui-object-navigation-main-page>